<template>
  <div class="page-container" style="min-height: 800px;">
    <div class="page-title-container">
      <h1 class="title-text">Welcome back!</h1>
      <h2 class="subtitle-text">
        The easiest way to post a job offer everywhere with one submission
      </h2>
    </div>

    <div class="center-items" style="flex-direction: column;">
      <p v-if="showServerError" class="p-error">
        ⚠️ Server error, conact the developers
      </p>
      <p v-if="showBadPassword" class="p-error">
        ⚠️ Incorrect email or password
      </p>
      <p v-if="showMissingError" class="p-error">
        ⚠️ Missing fields from below
      </p>
      <p v-if="showEmailBadFormat" class="p-error">
        ⚠️ Bad format email, try name@domain.com
      </p>

      <div class="signup-container">
        <div style="text-align: center; margin-top: 0px;">
          <p style="margin-top: 0px;">
            Don't have an account?
            <router-link to="/sign-up">Sign up</router-link>
          </p>
        </div>

        <div style="margin-bottom: 1.5rem;">
          <p style="margin-bottom: 0.5rem;">Email adress*</p>
          <input
            class="input-container input-container-medium"
            style="width: 100%;"
            placeholder="Enter your email"
            ref="email"
            v-model="email"
            @click="select($refs.email, email)"
            type="text"
            @keyup.enter="select($refs.password, password)"
            maxlength="1000"
          />
        </div>

        <div style="margin-bottom: 1.5rem;">
          <p style="margin-bottom: 0.5rem;">Password*</p>
          <input
            class="input-container input-container-medium"
            style="width: 100%;"
            placeholder="Enter your password"
            ref="password"
            v-model="password"
            @click="select($refs.password, password)"
            type="password"
            @keyup.enter="login"
            maxlength="1000"
          />
          <div style="text-align: right;">
            <p style="margin-top: 0px; font-size: 0.9rem;">
              <router-link to="/password-reset">I forgot my password</router-link>
            </p>
          </div>
        </div>

        <button type="button" class="primary-button medium-button" style="width: 100%; margin-left: 0px;" @click="login">
          Log in
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
import * as validator from "email-validator";

export default {
  data() {
    return {
      showEmailBadFormat: false,
      showMissingError: false,
      showServerError: false,
      showBadPassword: false,
      email: "",
      password: "",
    };
  },

  created() {
    window.scrollTo(0, 0);
  },

  methods: {
    select(ref, model) {
      ref.focus();
      ref.setSelectionRange(0, model.length);
    },

    async login() {
      this.showEmailBadFormat = false;
      this.showMissingError = false;
      this.showServerError = false;
      this.showBadPassword = false;

      if (this.email == null || this.email == "") {
        this.showMissingError = true;
        this.select(this.$refs.email, this.email);
        this.email = "";
        this.password = "";
        return;
      }

      if (!validator.validate(this.email)) {
        this.showEmailBadFormat = true;
        this.select(this.$refs.email, this.email);
        this.password = "";
        return;
      }

      if (this.password == null || this.password == "") {
        this.showMissingError = true;
        this.select(this.$refs.password, this.password);
        this.password = "";
        return;
      }

      if (this.showEmailBadFormat || this.showMissingError) {
        return;
      }

      firebase.auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.loginSuccess("emailAndPassowrd");
        })
        .catch((error) => {
          this.loginError(error);
        });
    },

    loginSuccess(method) {
      firebase.analytics.logEvent("login", { method });
      this.$router.push({ path: "/dashboard" });
    },

    loginError(error) {
      if (error.code === "auth/wrong-password") {
        this.showBadPassword = true;
      } else {
        this.showServerError = true;
      }
      this.select(this.$refs.email, this.email);
      this.password = "";
      console.error(error.message);
    },
  },
};
</script>

<style></style>
